import { requestApi } from '../util/network'

// 获取系统概括列表
export const getSellerIndex =
    () =>
      requestApi(
        '/index.php/seller/Seller/seller',
        'GET',
				{
				},
				'sale'
      )

// 获取销售商品查询列表
export const getSellerGoods =
    (addInfo) =>
      requestApi(
        '/seller/Sellergoods/index',
        'GET',
				addInfo,
				'sale'
      )

// 获取销售商品属性
export const getGoodsAttribute =
    (commonId) =>
      requestApi(
        '/seller/Sellergoods/goods_decs',
        'GET',
				{
					'commonid': commonId
				},
				'sale'
      )

// 上传商品
export const uploadGoods =
    (commonId) =>
      requestApi(
        '/seller/Sellergoods/shopUploadSave',
        'POST',
				{
					'goods_commonid': commonId
				},
				'sale'
      )

// 手动更新库存
export const updateStorageSelf =
    (commonId) =>
      requestApi(
        '/seller/Sellergoods/updateStorage',
        'POST',
				{
					'goods_commonid': commonId
				},
				'sale'
      )

// 自动更新库存
export const updateStorage =
    (minute) =>
      requestApi(
        '/seller/Sellergoods/updateStorageConfig',
        'POST',
				{
					'config_minute': minute
				},
				'sale'
      )

// 自动更新库存-详情
export const getStorageInfo =
    () =>
      requestApi(
        '/seller/Sellergoods/updateStorageConfig',
        'GET',
				{
				},
				'sale'
      )

// 获取订单列表
export const getOrderList =
    (detail) =>
      requestApi(
        '/seller/Sellerorder/index',
        'GET',
				detail,
				'sale'
      )

// 删除订单
export const delOrder =
    (orderId) =>
      requestApi(
        '/seller/Sellerorder/order_del',
        'POST',
				{
					'order_id': orderId
				},
				'sale'
      )

// 获取订单详情
export const getOrderInfo =
    (orderId) =>
      requestApi(
        '/index.php/seller/Sellerorder/show_order',
        'POST',
				{
					'order_id': orderId
				},
				'sale'
      )

// 获取售后订单列表页
export const getAfterList =
    (detail) =>
      requestApi(
        '/seller/Sellerrefundreturn/index',
        'POST',
				detail,
				'sale'
      )

// 获取售后订单详情页
export const getAfterInfo =
    (afterId) =>
      requestApi(
        '/seller/Sellerrefundreturn/view',
        'GET',
				{
					'refund_id': afterId
				},
				'sale'
      )

// 获取售后订单详情页
export const editAfter =
    (state, message, refund) =>
      requestApi(
        '/seller/Sellerrefundreturn/edit',
        'POST',
				{
					'seller_state': state,
					'seller_message': message,
					'refund_id': refund
				},
				'sale'
      )

// 获取系统公告列表
export const getAnnouncement =
    () =>
      requestApi(
        '/seller/Announcement/index',
        'GET',
				{
				},
				'sale'
      )

// 获取系统公告详情
export const getAnnouncementView =
    (Id) =>
      requestApi(
        '/seller/Announcement/view',
        'GET',
				{
					'amt_id': Id
				},
				'sale'
      )
			
// 获取店铺管理信息
export const getStore =
    () =>
      requestApi(
        '/seller/Store/index',
        'GET',
				{
				},
				'sale'
      )

// 获取供货资源信息
export const getSource =
    () =>
      requestApi(
        '/seller/Source/index',
        'GET',
				{
				},
				'sale'
      )

// 获取订单销售统计信息
export const getSalesIndex =
    (type, sDate, eDate) =>
      requestApi(
        '/seller/Sales/index',
        'GET',
				{
					'type': type,
					'query_start_date': sDate,
					'query_end_date': eDate
				},
				'sale'
      )